export default __webpack_public_path__ + "static/media/touch-football.4cb618f7.svg";